<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <g clip-path="url(#clip0_1324_1944)">
    <path
      d="M7.25 8.43408V15.5708L1 11.9995V4.86279L7.25 8.43408ZM15 12.0005L8.75 15.5708V8.43408L15 4.86279V12.0005ZM10.5 10.23V11.9849L13.5 10.1626V8.40869L10.5 10.23ZM10.1758 5.89111L8 7.13525L1.75586 3.56689L4.15137 2.19775L10.1758 5.89111ZM14.2422 3.56787L11.6611 5.04248L5.63672 1.34912L8 -0.000488281L14.2422 3.56787Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_1324_1944">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</svg>
